export const QueryKeys = {
  AllVendorsList: 'AllVendorsList',
  ThirdPartyVendorToken: 'ThirdPartyVendorToken',
  AllFrameworksList: "AllFrameworksList",
  ControlSets: "ControlSets",
  StytchMembersList: "StytchMembersList",
  SessionDetails: "SessionDetails",
  Questionnaire: "Questionnaire"
};
